import { render, staticRenderFns } from "./DetailedAccountingGroups.vue?vue&type=template&id=15f2d0aa&"
import script from "./DetailedAccountingGroups.vue?vue&type=script&lang=js&"
export * from "./DetailedAccountingGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports